import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import { cn } from '@/utils/cn';

const gmCoinLevelVariants = cva('gm-level-coin relative flex items-center justify-center rounded-full', {
  variants: {
    appearance: {
      mobileBar: 'bg-c950 size-7.25',
      desktopWidget: 'size-7.25',
      levelUpCard: 'size-8',
    },
  },
  defaultVariants: {
    appearance: 'mobileBar',
  },
});

const gmCoinValueVariants = cva(
  'relative z-3 text-center font-semibold tracking-normal whitespace-nowrap text-c900',
  {
    variants: {
      appearance: {
        mobileBar: 'min-w-3.75 leading-4',
        desktopWidget: 'min-w-3.75 leading-4',
        levelUpCard: 'min-w-4 leading-2.75',
      },
    },
    defaultVariants: {
      appearance: 'mobileBar',
    },
  },
);

interface GmLevelCoinProps extends VariantProps<typeof gmCoinLevelVariants> {
  className?: string;
  levelNumber: number;
}

export const GmLevelCoin = ({ className, levelNumber, appearance }: GmLevelCoinProps) => {
  return (
    <div className={cn(gmCoinLevelVariants({ appearance }), className)}>
      <span aria-hidden className="gm-level-coin-rim" />
      <span aria-hidden className="gm-level-coin-face" />
      <span
        className={cn(
          gmCoinValueVariants({ appearance }),
          levelNumber >= 10 ? 'text-[0.625rem]' : 'text-sm',
        )}
      >
        {levelNumber}
      </span>
    </div>
  );
};
